import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import User from 'models/user';

const propTypes = {
  user: PropTypes.instanceOf(User).isRequired,
};

const AuthenticatedAccountInformation = ({
  user,
}) => {
  if (!user.isLoggedIn()) { return null; }

  const { email } = user;
  return (
    <div className="border-color-light-grey border-side-top border-style-solid padding-top-20">
      <h2 className="text-color-dark-slate text-size-20 text-weight-bold margin-top-0">
        <FormattedMessage
          id="common.your-information"
          defaultMessage="Your Information"
        />
      </h2>
      <div className="row text-size-12 text-weight-book margin-bottom-10">
        <div className="text-size-14 col-xs-12">
          <FormattedMessage
            id="checkout.signed-in-as"
            defaultMessage="Signed in as {emailElement}"
            values={{
              emailElement: (
                <span className="text-weight-medium">
                  { email }
                </span>
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
};

AuthenticatedAccountInformation.propTypes = propTypes;
export default AuthenticatedAccountInformation;
